import registerForRails from 'js/utils/registerForRails';
import AdminBar from 'js/admin_bar/AdminBarActivator';
import LoggedOutBucketingBar from 'js/logged_out_bucketing_bar/LoggedOutBucketingBar';
import JournalSubscriptionPage from 'js/journals/subscriptions/JournalSubscriptionPage';
import JournalNavbar from 'js/journals/JournalNavbar';
import PublishingNavbar from 'js/journals/PublishingNavbar';
import { trackCWV } from 'js/utils/trackCWV';
trackCWV();

// The URL can carry a 90-day token naming a person, and the server already closes the vectors
// that would copy it onward (noindex, GA4, Referer, the request log, the hit record). This
// closes the last one it cannot reach: the address bar and browser history, where the link
// outlives the visit and travels by screenshot or shared machine. Safe to drop because nothing
// client-side reads it from the URL — the token reaches the page through its props.
//
// This also has to beat loadRecordHit, which posts window.location.href to /record_hit for
// logged-out visitors. It does: the rewrite below is synchronous top-level entry code, while
// handleRecordHit defers behind domLoadedPromise() — which waits a tick even when the document
// is already complete — so the token is gone from the URL before the hit is built.
//
// Only the token key is removed, unlike the recommendation survey entry this otherwise mirrors.
// That page is reachable only from an email, so its query string holds nothing else; this one
// is also a public campaign landing page, and its GA4 is suppressed only on token visits, so
// blanking the whole query string would erase utm_* and gclid from exactly the ordinary visits
// that still report them.
const params = new URLSearchParams(window.location.search);
if (params.has('prefs_token')) {
  params.delete('prefs_token');
  const query = params.toString();
  window.history.replaceState(
    {},
    '',
    query ? `${window.location.pathname}?${query}` : window.location.pathname,
  );
}

registerForRails(
  {
    JournalSubscriptionPage,
  },
  ['js/journals/subscriptions/JournalSubscriptionPage'],
);

// Both navbars, because show.html.slim picks between them per page: a journal's subscribe page
// wears that journal's navbar, the all-journals page wears the publishing-wide one.
registerForRails(
  {
    AdminBar,
    LoggedOutBucketingBar,
    JournalNavbar,
    PublishingNavbar,
  },
  [
    'js/admin_bar/AdminBar',
    'js/journals/JournalNavbar',
    'js/journals/PublishingNavbar',
  ],
);
